import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AudioVoiceProvider } from './context/AudioVoiceContext';
import { ContinuousPlayerProvider } from './context/ContinuousPlayerContext';
import Navbar from './components/Navbar';
import MiniPlayer from './components/MiniPlayer';
import Home from './components/Home';
import Chapters from './components/Chapters';
import ChapterDetail from './components/ChapterDetail';
import SlokaDetail from './components/SlokaDetail';
import Speakers from './components/Speakers';
import Listen from './components/Listen';
import ListenStream from './components/ListenStream';
import Bookmarks from './components/Bookmarks';
import ReadMode from './components/ReadMode';
import Watch from './components/Watch';
import FamilyTree from './components/FamilyTree';
import './App.css';

function TrailingSlashRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.length > 1 && location.pathname.endsWith('/')) {
      navigate(
        {
          pathname: location.pathname.replace(/\/+$/, ''),
          search: location.search,
          hash: location.hash
        },
        { replace: true }
      );
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}

function AppLayout() {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/+$/, '') || '/';
  const isStream = pathname === '/listen/stream';
  const isListen = pathname.startsWith('/listen');
  const isWatch  = pathname === '/watch';

  return (
    <div
      className={`${isListen || isWatch ? 'listen-route-root' : 'app-shell'} ${
        isStream ? 'bg-[#1a0a0f]' : isWatch ? 'bg-[#0f0408]' : isListen ? '' : ''
      }`}
    >
      {!isListen && !isWatch && <Navbar />}
      <main className={isListen || isWatch ? 'listen-route-main' : 'app-main'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chapters" element={<Chapters />} />
          <Route path="/chapter/:number" element={<ChapterDetail />} />
          <Route path="/sloka/:id" element={<SlokaDetail />} />
          <Route path="/speakers" element={<Speakers />} />
          <Route path="/bookmarks" element={<Bookmarks />} />
          <Route path="/read/:number" element={<ReadMode />} />
          <Route path="/watch" element={<Watch />} />
          <Route path="/listen" element={<Listen />} />
          <Route path="/listen/stream" element={<ListenStream />} />
          <Route path="/listen/spotify" element={<Navigate to="/listen/stream" replace />} />
          <Route path="/family" element={<FamilyTree />} />
        </Routes>
      </main>
      <MiniPlayer />
    </div>
  );
}

function App() {
  return (
    <AudioVoiceProvider>
      <ContinuousPlayerProvider>
        <Router>
          <TrailingSlashRedirect />
          <AppLayout />
        </Router>
      </ContinuousPlayerProvider>
    </AudioVoiceProvider>
  );
}

export default App;
